import { Box } from "@novel/shared/components/Box";
import styled from "styled-components";
export const SubduedText = styled(Box)`
    font-size: 14px;
    opacity: 0.7;
`;
export const NormalText = styled(Box)`
    font-size: 14px;
`;
export const EmphasizedText = styled(Box)`
    font-size: 14px;
    font-weight: bold;
`;
export const SectionTitleText = styled(Box)`
    color: #202223;
    font-size: 16px;
    font-weight: 600;
`;
export const SectionBodyText = styled(Box)`
    color: #6d7175;
    font-size: 14px;
    font-weight: 400;
`;